import React, {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

const useUrlParams = () => {
  const {search} = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};

export default useUrlParams;
